import React from "react";
import firebase from "firebase/app";
import SearchUsers from "./SearchUsers";
import { UserUpdates } from "./UserUpdates";
import styled from "@emotion/styled";

interface IProps {
  user: firebase.User;
}

const Container = styled.div({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
})

const Sidebar = styled.div({
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 400,
  flexShrink: 0,
  background: 'rgb(250, 250, 255)',
})

const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: '12px 40px',
})

const AdminPanel = ({ user }: IProps) => {
  const handleLogOut = (event: React.MouseEvent) => {
    event.preventDefault();
    firebase.auth().signOut();
  };
  return (
    <Container>
      <Sidebar>
        Logged in as <b>{user.email}</b>
        <p>
          <button onClick={handleLogOut}>Log out</button>
        </p>
        <h2>User management</h2>
        <UserUpdates user={user} />
      </Sidebar>
      <Content>
        <SearchUsers user={user} />
      </Content>
    </Container>
  );
};

export default AdminPanel;
